import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from '../ModalGeneral';

class ErrorModal extends React.Component {
  getCheckoutContent() {
    return (
      <FormattedMessage
        id='errorModal.content.description'
        defaultMessage={`We didn’t expect this to happen. \nApologies for the inconvenience.`}
      />
    );
  }

  render() {
    const { show } = this.props;
    const header = (
      <FormattedMessage
        id='errorModal.header.title'
        defaultMessage='Something went wrong'
      />
    );
    const primaryLabel = (
      <FormattedMessage id='errorModal.footer.ok' defaultMessage='Ok' />
    );
    const content = this.getCheckoutContent();
    return (
      <Modal
        show={show}
        header={header}
        onPrimaryClick={this.props.onPrimaryClick}
        content={content}
        backdropColor='black'
        underlineColor='red'
        primaryLabel={primaryLabel}
      />
    );
  }
}

ErrorModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onPrimaryClick: PropTypes.func.isRequired,
};

export default ErrorModal;
